/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateTaskTemplate} from '../api'

export const useMutationUpdateTaskTemplate = createReactQueryMutationHook('updateTaskTemplate', updateTaskTemplate)
